export default "__VITE_ASSET__C5XkP1J3__"